import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-76" data-mp="1l9o779vjm1m9">
      <div className="mx-auto max-w-2xl" data-id="element-77" data-mp="1ge0fontl8wdl">
        <div className="text-center" data-id="element-78" data-mp="1gauuhjo2yen5">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-79" data-mp="2e0pn5d72816u">
            Encore des doutes ?
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-navy sm:text-[2.6rem]" data-id="element-80" data-mp="2924m5bjzhdhc">
            Questions <span className="italic text-grape" data-id="element-81" data-mp="1z3ff6dtmldfv">Fréquentes</span>
          </h2>
        </div>

        <div className="mt-10 space-y-3" data-id="element-82" data-mp="smv26fb4eg6g">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-2xl bg-white" data-id="element-83" data-mp="nmgtqw5lx47w" data-mpi={index}>
                <h3 data-id="element-84" data-mp="pizf3w92p2fb">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-teal/40" data-id="element-85" data-mp="pipme0wn8h5x">
                    <span className="text-sm font-bold text-navy" data-id="element-86" data-mp="6r6jdu2md33w">{faq.q}</span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-teal transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-87" data-mp="bhwqpculvg18" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-88" data-mp="3jxghm57t0md4">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-89" data-mp="3nzbrvz7pqa31">
                      <p className="px-6 pb-5 text-sm leading-relaxed text-navy/60" data-id="element-90" data-mp="1krkru8q86eyr">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}